import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

/**
 * Toast — istanza globale di `react-toastify` con config standard del DESIGN.md.
 *
 * Da montare UNA sola volta in `src/main.jsx` (sotto `<App />`). I componenti
 * di business chiamano `toast.success(...)` / `toast.error(...)` / `.warn` /
 * `.info` direttamente da `react-toastify` — non c'è bisogno di un wrapper
 * imperativo: la libreria è già designata come singleton.
 *
 * Config (allineata a DESIGN.md):
 * - position `top-right`
 * - autoClose 5000 ms
 * - newestOnTop, closeOnClick, draggable, theme `light`
 */
export default function Toast() {
  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  );
}
